import { Button, styled } from '@mui/material';

export const OutlinedButton = styled(Button)(({ theme }) => ({
    width: '100%',
    color: '#007CB0',
    backgroundColor: 'transparent',
    border: '1px solid #007CB0',
    ':hover': {
        color: '#FFF',
        backgroundColor: '#007CB0',
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: '5px',
        fontSize: '12px',
    },
}));
